import { render, staticRenderFns } from "./energy_comparison.vue?vue&type=template&id=391f9eda&"
import script from "./energy_comparison.vue?vue&type=script&lang=js&"
export * from "./energy_comparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports